export default import.meta.ROLLDOWN_FILE_URL_qdN_CrI_i6cxNZNR4eAafA